import React from 'react';

import { Center } from '@mantine/core';
import { useSubscriptionContext } from 'contexts/SubscriptionContext';
import { Navigate } from 'react-router-dom';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { ProductName } from 'shared/interfaces/Product';

export function PayWallPage() {
  const [subscription] = useSubscriptionContext();
  const isPaidAccount = subscription.product.name !== ProductName.STARTER;
  if (isPaidAccount) return <Navigate to={ROUTE_LINKS.smartAssistants} />;

  return (
    <Center sx={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe
        src="https://www.droxy.ai/embeddable/pricing"
        style={{
          width: '100%',
          height: '90vh',
          border: 'none',
          overflow: 'hidden',
          margin: '0 auto'
        }}
        title="Droxy Pricing"
      />
    </Center>
  );
}
